module.exports = __webpack_public_path__ + "img/phone-flip.7139b9ca.svg";